import { useHistory, useParams } from 'react-router-dom';
import { Button } from '../components/Button';
import { RoomCode } from '../components/RoomCode';
import { useAuth } from '../hooks/useAuth';
import { Question } from '../components/Question';
import { useRoom } from '../hooks/useRoom';
import { database } from '../services/firebase';
import toast, { Toaster } from 'react-hot-toast';
import { ConfirmModal } from '../components/ConfirmModal';

import '../styles/room.scss';
import logoImg from '../assets/images/Logo.svg';
import removeImg from '../assets/images/Messages/trash.svg';
import checkedImg from '../assets/images/Messages/checkmark.svg';
import ballonImg from '../assets/images/Messages/ballon.svg';

type RoomParams = {
  id: string;
}

export function AdminRoom() {
  const { user, signOut, signInWithGoogle } = useAuth();
  const history = useHistory();
  const params = useParams<RoomParams>();
  const roomId = params.id;

  const { questions, title } = useRoom(roomId);

  function errorMessage() {
    return toast('You have been denied permission to access this function', { icon: '⚠️' });
  }

  async function handleDeleteQuestion(questionId: string) {
    if (!user) {
      errorMessage()
      return;
    }
    await database.ref(`rooms/${roomId}/questions/${questionId}`).remove();
  }

  async function handleClosedRoom() {
    if (!user) {
      errorMessage();
      return;
    }

    const roomRef = await database.ref(`rooms/${roomId}`).get();
    if (roomRef.val().closedAt) {
      return toast('Room already closed.', { icon: '⚠️' });
    }

    await database.ref(`rooms/${roomId}`).update({
      closedAt: new Date(),
    })

    history.push('/');
  }

  async function handleCheckQuestionAsAnswered(questionId: string) {
    if (!user) {
      errorMessage()
      return;
    }
    await database.ref(`rooms/${roomId}/questions/${questionId}`).update({
      isAnswered: true,
    });
  }

  async function handleHighLightQuestion(questionId: string) {
    if (!user) {
      errorMessage();
      return;
    }

    await database.ref(`rooms/${roomId}/questions/${questionId}`).update({
      isHighlighted: true,
    });
  }

  return (
    <div id="page-room">
      <header>
        <div className="content">
          <img src={logoImg} alt="Letmeask" />
          <div>
            <RoomCode code={roomId} />
            {
              user
                ? <Button isOutlined onClick={signOut} >Sair</Button>
                : <Button isOutlined onClick={signInWithGoogle}> Sign In</Button>
            }
          </div>
        </div>
      </header>

      <main>
        <div className="room-title">
          <Toaster toastOptions={{ className: "dark-toast" }} />
          <h1>Sala {title}</h1>
          {
            questions.length > 0 && <span>{questions.length} pergunta(s)</span>
          }
          <Button isOutlined onClick={handleClosedRoom}>Encerrar sala</Button>
        </div>
        <div className="question-list">
          {questions.length === 0 && title !== '' ?
            <p>Você não possui perguntas nesta sala</p>
            :
            questions
              .sort((a, b) => b.likeCount - a.likeCount)
              .map(question => {
                return (
                  <Question
                    key={question.id}
                    content={question.content}
                    author={question.author}
                    isAnswered={question.isAnswered}
                    isHighlighted={question.isHighlighted}
                  >
                    {!question.isAnswered && (
                      <>
                        <button
                          type="button"
                          onClick={() => handleCheckQuestionAsAnswered(question.id)}
                        >
                          <img src={checkedImg} alt="Marcar pergunta como respondida" />
                        </button>

                        <button
                          type="button"
                          onClick={() => handleHighLightQuestion(question.id)}
                        >
                          <img src={ballonImg} alt="Dar destaque à pergunta" />
                        </button>
                      </>
                    )}
                    <ConfirmModal
                      title="Excluir pergunta"
                      content="Tem certeza que deseja excluir esta pergunta?"
                      txtBtnCancel="Cancelar"
                      txtBtnConfirm="Sim, excluir"
                      onClick={() => handleDeleteQuestion(question.id)}
                    >
                      <img src={removeImg} alt="Remover pergunta" />
                    </ConfirmModal>
                  </Question>
                );
              })
          }
        </div>
      </main>
    </div>
  );
}